import { useEffect, useState } from "react";
import ProductCategoryTable from "./ProductCategoryTable";
import ProductCategoryModal from "./ProductCategoryModal";
import Modal from "components/common/Modal";
import { useProductCategory } from "./hooks/useProductCategory";
import { useOrganizers } from "components/company/hooks/useOrganizers";
import Alert from "components/common/Alert";

export default function ProductCategoryContainer() {
  const {
    data,
    loading,
    loadCategories,
    addCategory,
    editCategory,
    deleteCategory,
  } = useProductCategory();

  const { companies } = useOrganizers();

  const [editing, setEditing] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);

  const [alert, setAlert] = useState({
  type: "",
  message: "",
});

  
  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  // const userId = localStorage.getItem("user_id");
  const userId = "69579c6190a653b640e65639";

  useEffect(() => {
    if (selectedOrganizer) {
      loadCategories(selectedOrganizer);
    }
  }, [selectedOrganizer]);

  useEffect(() => {
  const handleOrganizerChange = (e) => {
    setSelectedOrganizer(e.detail);
  };

  window.addEventListener("companyChanged", handleOrganizerChange);
  return () =>
    window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);



  // const defaultOrganizerId = companies?.[0]?._id;

  // const defaultOrganizerId = "69410617a1c7c7664e634047";


  // useEffect(() => {
  //   if (defaultOrganizerId) {
  //     loadCategories(defaultOrganizerId);
  //   }
  // }, [defaultOrganizerId]);

  return (
    <>
      <div className="mb-4 flex justify-end">
        <button
          className="rounded bg-blue-600 px-4 py-2 text-white"
          onClick={() => setOpenAdd(true)}
        >
          + Add Category
        </button>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      <ProductCategoryTable
        data={data}
        loading={loading}
        onEdit={setEditing}
        onDelete={async (row) => {
          try {
            const res = await deleteCategory(row._id, {
              is_deleted: true,
              deleted_by: userId || null,
            });
            setAlert({
              type: "success",
              message: res.data?.message || "Category deleted successfully",
            });

            loadCategories(selectedOrganizer);
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Something went wrong while deleting category",
            });
          }
        }}
      />


      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <ProductCategoryModal
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("created_by", userId);

              await addCategory(payload);

              setOpenAdd(false);
              loadCategories(selectedOrganizer);
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                "Something went wrong while creating category"
              );
            }
          }}
        />
      </Modal>


      
      <Modal open={!!editing} onClose={() => setEditing(null)}>
        <ProductCategoryModal
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("updated_by", userId);

              await editCategory(editing._id, payload);

              setEditing(null);
              loadCategories(selectedOrganizer);
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                "Something went wrong while updating category"
              );
            }
          }}
        />
      </Modal>


    </>
  );
}
